import React, { useState, useEffect } from "react";
import Layout from "../layout/Layout";
import { VscCircleFilled } from "react-icons/vsc";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../apiInstances/axiosInstance";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useEncryption from "../useEncryption/useEncryption";
import { toast } from "react-toastify";
import io from "socket.io-client";
import { FaUserTie, FaUsers } from "react-icons/fa";

import UserNotification from "../Notification/NotificationUser";
import AdminNotification from "../Notification/NotificationAdmin";

const Notification = () => {
  const { decryptData } = useEncryption();

  const [allNotification, setAllNotification] = useState([]); // use User Table time this state
  const [showModal, setShowModal] = React.useState(false); // Delete Popup

  const getNotificationdata = async () => {
    let apiEndpoint = "/mynotifications";

    const userRole = localStorage.getItem("Role");

    if (userRole === "user") {
      apiEndpoint = "/Usernotifications"; // Change API endpoint for user role
    }

    try {
      const res = await axiosInstanceAuth.get(apiEndpoint);
      // console.log("API Response:", res); // Log the entire response
      const myData = decryptData(res?.data?.data);
      setAllNotification(myData?.data || []);
      // console.log("Notification Show---->", myData);
    } catch (err) {
      console.log("err --->", err);
    }

    // await axiosInstanceAuth
    //   .get("/mynotifications")
    //   .then((res) => {
    //     const myData = decryptData(res?.data?.data);
    //     setAllNotification(myData?.data || []);
    //     console.log("Notification Show---->", myData);
    //   })
    //   .catch((err) => {
    //     console.log("err --->", err);
    //   });
  };

  // useEffect(() => {
  //   getNotificationdata();
  // }, []);

  // Delete API
  const clearNotificationApi = async () => {
    await axiosInstanceAuth
      .get(`/clearnotification`)
      .then((res) => {
        const myClearData = decryptData(res?.data?.data);
        console.log("Clear Notification Done --->", myClearData);
        if (myClearData.status) {
          getNotificationdata();
          toast.success(myClearData?.message);
        } else {
          toast.error(myClearData?.message);
        }
        setShowModal(false);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };
  // useEffect(() => {
  //   // Handle incoming notifications
  //   socket.on("notification", (message) => {
  //     console.log("::------", message);
  //     setAllNotification((prevNotifications) => [
  //       ...prevNotifications,
  //       message,
  //     ]);
  //   });
  //   // Clean up the socket connection on component unmount
  //   socket.on("connect", () => {
  //     console.log("Socket connected");
  //     getNotificationdata();
  //   });

  //   return () => {
  //     socket.disconnect("notification");
  //     console.log("Socket disconnected on component unmount");
  //   };
  // }, []);
  const renderNotifications = () => {
    if (!Array.isArray(allNotification) || allNotification.length === 0) {
      return (
        <div className="">
          <div className="text-5xl font-sans font-bold text-center mt-80 text-[#22345C]">
            No Notification !
          </div>
        </div>
      );
    }

    let currentDate = null;

    return allNotification?.map((notification, index) => {
      const isNewDate = notification.date !== currentDate;

      if (isNewDate) {
        currentDate = notification.date;
      }

      return (
        <div
          key={index}
          className={`mt-5 space-y-3 ${isNewDate ? "border-t pt-3" : ""}`}
        >
          {isNewDate && (
            <div className="text-[#22345C] font-sans font-semibold">
              {notification.date}
            </div>
          )}
          <div className="rounded-md shadow-lg flex items-center gap-2 bg-white px-3 py-3">
            <div>
              <VscCircleFilled size={20} className="text-[#22345C]" />
            </div>
            <div className="font-medium font-sans text-base text-justify">
              {notification.message}
            </div>
          </div>
        </div>
      );
    });
  };

  const AdminComponent = () => (
    <div>
      <AdminNotification />
    </div>
  );

  const UserComponent = () => (
    <div>
      <UserNotification />
    </div>
  );

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(!isChecked);
  };

  const [userRole, setUserRole] = useState(""); // Role wise manage
  useEffect(() => {
    const userRole = localStorage.getItem("Role");
    if (userRole) {
      setUserRole(userRole);
    }
  }, []);

  return (
    <Layout>
      <div className="container">
        {userRole !== "user" && (
          <div className="flex justify-center my-10">
            <label className="themeSwitcherTwo shadow-card relative inline-flex cursor-pointer select-none items-center justify-center rounded-md bg-white p-1">
              <input
                type="checkbox"
                className="sr-only"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <span
                className={`flex items-center space-x-[6px] rounded py-2 px-[18px] text-base font-medium ${
                  !isChecked ? "text-white bg-[#22345C]" : "text-body-color"
                }`}
              >
                <FaUserTie size={18} className="mr-2" />
                Admin
              </span>
              <span
                className={`flex items-center space-x-[6px] rounded py-2 px-[18px] text-base font-medium ${
                  isChecked ? "text-white bg-[#22345C]" : "text-body-color"
                }`}
              >
                <FaUsers size={18} className="mr-2" />
                User
              </span>
            </label>
          </div>
        )}

        {isChecked ? <UserComponent /> : <AdminComponent />}
        <ToastContainer />
      </div>
    </Layout>
  );
};

export default Notification;
